const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/public/leader-context-document.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
/**
 * Leader Context Document 원본 양식(9섹션) 항목 제목.
 *
 * 백엔드 src/contexts/coaching/domain/constants/leader-context-document-form.constant.ts 와 같은 문구다.
 * 제출 결과를 LCD 본문(파일)로 렌더하므로 원본 템플릿과 글자 단위로 일치해야 한다.
 * 수정 시 함께 바꿔야 한다. (레포가 달라 import로 묶을 수 없음)
 */
const LABELS = {
  positionHistory: '직책/포지션/히스토리',
  organizationContext: '조직 특성',
  mainRoles: '리더의 주요 역할/업무',
  strengths: '리더의 강점',
  improvements: '리더의 보완·개선 필요하다고 관찰되는 영역, 바라는 부분, 기대하는 변화',
  currentIssue: '최근 이슈: “지금” 코칭이 필요하다고 생각하시는 이유',
  receptivity: '금번 코칭에 대한 수용도',
  otherComments: '기타 의견'
} as const;
type FieldKey = keyof typeof LABELS;

/** 마지막 항목. 원본 템플릿에는 없고 웹 폼에만 있다. 백엔드 LEADER_CONTEXT_DOCUMENT_LABELS.caseSharing 과 같은 문구. */

/** 워드 템플릿의 [SAMPLE] 작성 예시 (원문 그대로). ? 아이콘 툴팁으로 노출한다. */

// otherComments만 선택

export const Route = createFileRoute('/public/leader-context-document')({
  validateSearch: search => {
    return {
      redirectToken: search.redirectToken as string ?? '',
      cycleId: search.cycleId as string ?? ''
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}